import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
const HostelWorkersList = ({ userData }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const view = (row) => {
    navigate(`/view-hostel-workers`, { state: row });
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [staff, setStaff] = useState({
    name: "",
    father_name: "",
    post: "",
    date_of_birth: "",
    gender: "",
    doj: "",
    phone_number: "",
    aadhaar: null,
    staff_pan: null,
    hostel_name: null,
  });

  const [photo, setPhoto] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [error, setErrors] = useState({});

  useEffect(() => {
  }, []);

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error("No photo selected!");
      return;
    }
    setPhoto(file);
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setStaff((prevStaff) => ({
      ...prevStaff,
      [name]: value,
    }));
  };

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("father_name", data.father_name);
      formData.append("post", data.post);
      formData.append("date_of_birth", data.date_of_birth);
      formData.append("gender", data.gender);
      formData.append("doj", data.doj);
      formData.append("phone_number", data.phone_number);
      formData.append("aadhaar", data.aadhaar[0]); 
      formData.append("staff_pan", data.staff_pan[0]); 
      formData.append("hostel_name", data.hostel_name);

   

      setIsLoading(false);
      toast.success(t("Hostel worker added successfully!"));
      navigate("/hostelworkers");
    } catch (error) {
      setIsLoading(false);
      toast.error(t("Failed to add hostel worker. Please try again later."));
      console.error("Error adding hostel worker:", error);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleUpdateClick = () => {
    setModalOpen(true);
  };

  const back = () => {
    navigate(`/hostelworkers`);
  };

  return (
    <>
      <div className="px-2 px-md-4">
        <h5 className="my-4">{t("Add Hostel Worker Details")}</h5>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Photo")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="file"
                {...register("photo", { required: true })}
                accept="image/*"
                className="form-control"
                onChange={handlePhotoChange}
              />
              {errors.photo && (
                <div className="text-danger">{t("Photo is required")}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Name")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                {...register("name", { required: true })}
                className="form-control"
                onChange={handleChangeInput}
              />
              {errors.name && (
                <div className="text-danger">{t("Name is required")}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Father's Name")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                {...register("father_name", { required: true })}
                className="form-control"
                onChange={handleChangeInput}
              />
              {errors.father_name && (
                <div className="text-danger">{t("Father's Name is required")}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Post")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                {...register("post", { required: true })}
                className="form-control"
                onChange={handleChangeInput}
              />
              {errors.post && (
                <div className="text-danger">{t("Post is required")}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Date of Birth")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="date"
                {...register("date_of_birth", { required: true })}
                className="form-control"
                onChange={handleChangeInput}
              />
              {errors.date_of_birth && (
                <div className="text-danger">{t("Date of Birth is required")}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Gender")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                {...register("gender", { required: true })}
                className="form-control"
                onChange={handleChangeInput}
              >
                <option value="">{t("Select Gender")}</option>
                <option value="Male">{t("Male")}</option>
                <option value="Female">{t("Female")}</option>
              </select>
              {errors.gender && (
                <div className="text-danger">{t("Gender is required")}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Date of Joining")}
              </label>
              <input
                type="date"
                {...register("doj")}
                className="form-control"
                onChange={handleChangeInput}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Phone Number")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                {...register("phone_number", { required: true })}
                className="form-control"
                onChange={handleChangeInput}
              />
              {errors.phone_number && (
                <div className="text-danger">{t("Phone Number is required")}</div>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Aadhar Number")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                {...register("aadhar_number", { required: true })}
                className="form-control"
                onChange={handleChangeInput}
              />
              {errors.aadhar_number && (
                <div className="text-danger">{t("Aadhar Number is required")}</div>
              )}
            </div>
            
           
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Hostel Name")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                {...register("hostel_name", { required: true })}
                className="form-control"
                onChange={handleChangeInput}
              />
              {errors.hostel_name && (
                <div className="text-danger">{t("Hostel Name is required")}</div>
              )}
            </div>
          </div>

          <div className="mt-4">
            <Button
              type="submit"
              variant="contained"
              id="btn"
              disabled={isLoading}
            >
              {isLoading ? t("Adding...") : t("Add Hostel Worker")}
            </Button>
            <Button id="btn" className="mx-3" onClick={() => view()}>
              {t("Back to List")}
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default HostelWorkersList;
